// Сообщение формы по макету выводится над заголовком страницы, то есть вне
// формы. Саму плашку Contact Form 7 выносить туда нельзя: плагин обновляет
// текст только внутри формы (form.querySelectorAll(".wpcf7-response-output")),
// и вынесенная плашка навсегда застывает на первом сообщении. Поэтому свою
// плашку рисуем отдельно и наполняем её текстом из события плагина.

const BANNER_CLASS = "complain-page__response";

const getBanner = (form) => {
	const container = form.closest(".container-800");
	const pageTitle = container?.querySelector("h1");

	if (!container || !pageTitle) {
		return null;
	}

	let banner = container.querySelector("." + BANNER_CLASS);

	if (!banner) {
		banner = document.createElement("div");
		// Класс плагина нужен для оформления плашки, role — для скринридеров.
		banner.className = "wpcf7-response-output " + BANNER_CLASS;
		banner.setAttribute("role", "alert");
		pageTitle.before(banner);
	}

	return banner;
};

// Сообщения задаются в определении формы в виде «Заголовок || Текст».
const renderMessage = (banner, message) => {
	banner.textContent = "";

	if (!message) {
		return;
	}

	const [title, text] = message.includes("||")
		? message.split("||").map((part) => part.trim())
		: [null, message.trim()];

	if (title) {
		const titleEl = document.createElement("strong");
		titleEl.className = "response-title";
		titleEl.textContent = title;
		banner.append(titleEl);
	}

	if (text) {
		const textEl = document.createElement("span");
		textEl.className = "response-text";
		textEl.textContent = text;
		banner.append(textEl);
	}
};

const showResponse = (e) => {
	const form = e.target;
	const banner = getBanner(form);

	if (!banner) {
		return;
	}

	renderMessage(banner, e.detail?.apiResponse?.message || "");

	// Собственную плашку плагина скрываем, чтобы сообщение не дублировалось.
	// Именно скрываем, а не удаляем: плагин продолжает писать в неё текст.
	form.querySelectorAll(".wpcf7-response-output").forEach((output) => {
		output.style.display = "none";
	});
};

const markUncheckedCheckboxes = (e) => {
	const form = e.target;

	form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
		if (checkbox.checked) {
			return;
		}

		const wrapper = checkbox.closest(".wpcf7-form-control-wrap");
		const formControl = checkbox.closest(".wpcf7-form-control");

		if (wrapper) {
			wrapper.classList.add("wpcf7-not-valid");
		}
		if (formControl) {
			formControl.classList.add("wpcf7-not-valid");
		}
	});
};

document.addEventListener("DOMContentLoaded", () => {
	// wpcf7submit приходит после любой попытки отправки — и удачной, и нет,
	// поэтому одного слушателя достаточно, чтобы текст всегда был актуальным.
	document.addEventListener("wpcf7submit", showResponse);
	document.addEventListener("wpcf7invalid", markUncheckedCheckboxes);

	document.querySelectorAll(".wpcf7").forEach((form) => {
		const checkboxes = form.querySelectorAll('input[type="checkbox"]');
		checkboxes.forEach((checkbox) => {
			checkbox.addEventListener(
				"change",
				(e) => {
					e.stopPropagation();
					e.stopImmediatePropagation();
				},
				true
			);
		});

		const textInputs = form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea');
		textInputs.forEach((input) => {
			input.addEventListener(
				"change",
				(e) => {
					e.stopPropagation();
					e.stopImmediatePropagation();
				},
				true
			);

			input.addEventListener(
				"blur",
				(e) => {
					e.stopPropagation();
					e.stopImmediatePropagation();
				},
				true
			);
		});
	});
});
